import { useEffect, useState } from "react";
import "./App.css";

import logo from "./assets/logo.png";
import bg from "./assets/background.png";
import slide1 from "./assets/slide1.jpg";
import slide2 from "./assets/slide2.jpg";
import slide3 from "./assets/slide3.jpg";
import slide4 from "./assets/slide4.jpg";

function App() {
  const slides = [slide1, slide2, slide3, slide4];
  const [currentSlide, setCurrentSlide] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 5000);

    return () => clearInterval(interval);
  }, [slides.length]);

  return (
    <>
      {/* Header */}
      <header style={{ backgroundImage: `url(${bg})` }}>
        <meta name="google-site-verification" content="Pf0rLUZa76HFImHSSVnRZdyCP2XCeYB80nbSYe0wkOE" />
        <img src={logo} alt="MyMenu Logo" className="logo" />
        <h1>MyMenu Digital Solution</h1>
        <p>
          Smart QR-Based Outlet System that helps businesses instantly showcase
          menus, products, prices, and business details — without any mobile app.
        </p>
        <div className="badge">Proudly Made in India 🇮🇳</div>
      </header>

      {/* What is MyMenu */}
      <section>
        <h2>🔍 What is MyMenu?</h2>
        <div className="highlight">
          <p>
            <strong>MyMenu</strong> is a digital QR-based system that allows
            customers to scan a QR code and instantly view:
          </p>
          <ul>
            <li>Menu / product list</li>
            <li>Prices</li>
            <li>Business details</li>
            <li>Contact & location</li>
          </ul>
          <p>No app installation required. Works on all smartphones.</p>
        </div>
      </section>

      {/* Slider */}
      <h2 style={{ textAlign: "center" }}>🔍 Example Web App</h2>
      <div className="slider">
        <img src={slides[currentSlide]} alt="Preview" />
      </div>

      <section className="cta">
        <a
          href="https://mymenutest.vercel.app/"
          target="_blank"
          rel="noreferrer"
        >
          Example web link
        </a>
      </section>

      {/* Why */}
      <section>
        <h2>🎯 Why Businesses Need This?</h2>
        <div className="grid">
          <div className="card">Contactless & quick viewing</div>
          <div className="card">Reduces staff workload</div>
          <div className="card">Modern business image</div>
          <div className="card">No printing cost</div>
          <div className="card">Easy updates anytime</div>
        </div>
      </section>

      {/* Advantages */}
      <section>
        <h2>✅ Key Advantages</h2>
        <div className="grid">
          <div className="card">✔ No app required</div>
          <div className="card">✔ Works on all phones</div>
          <div className="card">✔ One-time payment</div>
          <div className="card">✔ WhatsApp updates</div>
          <div className="card">✔ Professional presence</div>
          <div className="card">✔ Faster decisions</div>
        </div>
      </section>

      {/* Pricing */}
      <section className="pricing">
        <h2>💰 Pricing Model</h2>
        <ul>
          <li>One-time payment</li>
          <li>No monthly charges</li>
          <li>Advance to start</li>
          <li>Balance after setup</li>
        </ul>
      </section>

      {/* Support */}
      <section className="cta">
        <h2>📞 Support & Demo</h2>
        <p>Direct WhatsApp support • Quick updates</p>

        <a
          href="https://wa.me/917305450312?text=Hello%20I%20am%20interested%20in%20MyMenu%20Digital%20Solution"
          target="_blank"
          rel="noreferrer"
          style={{ background: "#25D366" }}
        >
          WhatsApp Support
        </a>

        <a
          href="mailto:mymenudigitalsolution@gmail.com"
          style={{ background: "#2563eb" }}
        >
          Email Support
        </a>
      </section>

      <footer>
        <p>© 2026 MyMenu Digital Solution. Built in India.</p>
      </footer>
    </>
  );
}

export default App;
